import React from 'react';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <h2 className="section-title">About Morning Light</h2>
          <p className="about-text">
            With over 15 years of dedicated experience in the funeral profession, Morning Light Funeral Services is a partner for funeral homes serving families of all faiths during their most difficult times. Our commitment to excellence is reflected not only in the personalized care we provide to each family but through presentation of our vehicles and staff representing your funeral home.
          </p>
          <p className="about-text">
            At Morning Light, we believe that a welcoming and serene environment plays a vital role in the healing process. We specialize in creating beautiful, respectful settings for memorial services, ensuring that every detail reflects the honor and dignity of every loved one. We are proud to serve the community with integrity, compassion, and a focus on making every farewell a beautiful and memorable occasion.
          </p>
          <div className="about-features">
            <div className="feature">
              <h4>Available 24/7</h4>
              <p>Always here when you need us</p>
            </div>
            <div className="feature">
              <h4>Experienced Staff</h4>
              <p>Compassionate professionals</p>
            </div>
            <div className="feature">
              <h4>Personalized Care</h4>
              <p>Every service is unique</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
